export class BlocksApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Block an identity.
     */
    async block(identityId) {
        return this.client.post('/api/blocks', { identityId });
    }
    /**
     * Unblock an identity.
     */
    async unblock(identityId) {
        return this.client.delete(`/api/blocks/${encodeURIComponent(identityId)}`);
    }
    /**
     * Get blocked identities list.
     */
    async getBlocked(limit, cursor) {
        const params = new URLSearchParams();
        if (limit)
            params.set('limit', limit.toString());
        if (cursor)
            params.set('cursor', cursor);
        const query = params.toString();
        return this.client.get(`/api/blocks${query ? `?${query}` : ''}`);
    }
    /**
     * Check if an identity is blocked by you.
     */
    async checkBlocked(identityId) {
        return this.client.get(`/api/blocks/check/${encodeURIComponent(identityId)}`);
    }
    /**
     * Bidirectional block check: has either party blocked the other?
     */
    async checkBlockedByEither(identityId) {
        return this.client.get(`/api/blocks/check-either/${encodeURIComponent(identityId)}`);
    }
}
//# sourceMappingURL=blocks-api.js.map